import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import QToolLogo from '@/assets/icons/qtool.svg';
import { links } from '@/common/utils/links';
import { parseJWT } from '@/common/utils/parseJWT';
import { httpClient } from '@/config/httpClient';

import { useLogin } from '../../hooks/useLogin';
import SignIn from '../SignIn';

import * as style from './styles';

export default function Sso() {
  const [searchParams] = useSearchParams();
  const [isProcessingSso, setIsProcessingSso] = useState(false);
  const { identifyUser, saveToken } = useLogin();
  const { t } = useTranslation(['common', 'login/signIn']);
  const navigate = useNavigate();

  const ACCESS_TOKEN = Cookies.get('accessToken');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) return;

    if (ACCESS_TOKEN) {
      return navigate(links.panel);
    }

    setIsProcessingSso(true);
    httpClient.defaults.headers.Authorization = `Bearer ${token}`;

    identifyUser().finally(() => setIsProcessingSso(false));

    const parsedToken = parseJWT<{ exp: number; session_state: string }>(token);
    if (!parsedToken) return;

    saveToken(
      {
        expires_in: parsedToken.exp,
        session_state: parsedToken.session_state,
        access_token: token,
        id_token: '',
        refresh_expires_in: 0,
        refresh_token: '',
        scope: '',
      },
      true,
    );
  }, [ACCESS_TOKEN, searchParams, identifyUser, saveToken]);

  if (isProcessingSso) {
    return (
      <main className={style.main()}>
        <div className={style.loadingContainer()}>
          <img src={QToolLogo} alt="QTool" />
          <div className={style.spinner()} />
          <h2 className={style.loadingText()}>
            {t('login/signIn:ssoProcessing')}
          </h2>
          <p className={style.loadingSubtext()}>
            {t('login/signIn:ssoProcessingSubtext')}
          </p>
        </div>
      </main>
    );
  }

  return <SignIn />;
}
